// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"819":"57ef892a","924":"9314cb4f"}[chunkId] + ".chunk.js";
};